import React from "react"
import Config from "../../../config/config"

const StageStyles = React.lazy(() => import("./stage-style"))
const ProductionStyles = React.lazy(() => import("./production-style"))
const RouteComponents = React.lazy(() => import("../../route.component"))

export const StyleSelector = () => {

    const stageEnv = 'staging'

    const getEnv = () => {
        return Config && Config.env
    }

    return (
        <>
            <React.Suspense fallback={<></>}>
                {getEnv() === stageEnv && <StageStyles />}
                {getEnv() !== stageEnv && <ProductionStyles />}
                <RouteComponents />
            </React.Suspense>
        </>
    )
}